
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/store/product/[...data]",
      function () {
        return require("private-next-pages/[lang]/store/product/[...data].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/store/product/[...data]"])
      });
    }
  